import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {UtilsService} from "./utils.service";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";

@Injectable()
export class ExploreService {

  constructor(
    private httpClient: HttpClient,
    private utils: UtilsService
  ) { }


  list(query?): Observable<any> {

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.get(this.utils.apiEndpoint+'explore', {
      responseType: 'json',
      headers: httpHeaders
    });

  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/explore.service.ts